addEventListener("turbo:submit-start", ({target}) => {
	for (const field of target.elements) {
		field.disabled = true
	}

	let submitButton = target.querySelector("button[type=submit]");
	if (submitButton && submitButton.dataset.textLoading) {
		submitButton.innerText = submitButton.dataset.textLoading;
	}
});
